<div id="main" perfectScrollbar (psScrollY)="onPsScrollY($event)" class="h-100">
  <header class="header" [class.over]="showInfoContent">
    <mat-toolbar class="top-toolbar" [class.mat-elevation-z2]="settings.fixedHeader">
      <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
        <div fxLayout="row" fxLayoutAlign="center center">
          <a
            routerLink="/"
            fxLayout="row"
            fxLayoutAlign="start center"
            class="logo"
            ngClass.xs="mobile"
            (click)="closeSubMenus()"
          >
            <span class="mx-2">{{ 'GENERAL.ElMal3ab' | translate }}</span>
          </a>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" class="w-100">
          <button *ngIf="settings.menu == 'vertical'" mat-icon-button (click)="sidenav.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
          <app-flags-menu></app-flags-menu>
          <app-user-menu></app-user-menu>
        </div>
      </div>
    </mat-toolbar>
  </header>

  <mat-drawer-container class="page-wrapper">
    <mat-drawer
      #sidenav
      *ngIf="settings.menu == 'vertical'"
      [opened]="settings.sidenavIsOpened"
      [mode]="settings.sidenavIsPinned ? 'side' : 'over'"
      (openedStart)="showSidenav = !showSidenav"
      (closedStart)="showSidenav = !showSidenav"
      class="sidenav mat-elevation-z6"
      autoFocus="false"
    >
      <mat-toolbar *ngIf="settings.fixedSidenav" class="top-toolbar">
        <a routerLink="/" fxLayout="row" fxLayoutAlign="start center" class="logo">
          <img src="assets/img/logo.png" alt="logo" [@rotate]="showSidenav" />
          <span class="mx-2">EL-Mal3ab</span>
        </a>
      </mat-toolbar>
      <app-sidenav></app-sidenav>
    </mat-drawer>

    <mat-drawer-content>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>

  <div
    #backToTop
    fxLayout="row"
    fxLayoutAlign="center center"
    class="back-to-top"
    (click)="scrollToTop()"
  >
    <mat-icon>arrow_upward</mat-icon>
  </div>

  <mat-toolbar color="primary" class="footer" [class.full-width]="!showSidenav"> </mat-toolbar>
</div>
